import { EnumMbaColor } from './mba-amazon.constants';


/**------------------------------------------------------
 * Color Configurations (for Merch By Amazon)
 */
export const MBA_COLOR_SPECIFICATION: IAmazonMbaColor[] = [
	{
		code		: EnumMbaColor.NoColor,
		name		: 'No Color',
		colorCode	: EnumMbaColor.NoColor				// transparent color code
	},
	{
		code		: EnumMbaColor.Asphalt,
		name		: 'Asphalt',
		colorCode	: '#3f3e3c'
	},
	{
		code		: EnumMbaColor.BabyBlue,
		name		: 'Baby Blue',
		colorCode	: '#8fb8db'
	},
	{
		code		: EnumMbaColor.DeepBlue,
		name		: 'Deep Blue',
		colorCode	: '#6c8cb2'
	},
	{
		code		: EnumMbaColor.Black,
		name		: 'Black',
		colorCode	: '#000000'
	},
	{
		code		: EnumMbaColor.Stone,
		name		: 'Stone',
		colorCode	: '#DBC8B2'
	},
	{
		code		: EnumMbaColor.Brown,
		name		: 'Brown',
		colorCode	: '#31261d'
	},
	{
		code		: EnumMbaColor.Cranberry,
		name		: 'Cranberry',
		colorCode	: '#6e0a25'
	},
	{
		code		: EnumMbaColor.DarkHeather,
		name		: 'Dark Heather',
		colorCode	: '#494f4f',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.ForestGreen,
		name		: 'Forest Green',
		colorCode	: '#0f5b20'
	},
	{
		code		: EnumMbaColor.Grass,
		name		: 'Grass',
		colorCode	: '#5e9444'
	},
	{
		code		: EnumMbaColor.HeatherBlue,
		name		: 'Heather Blue',
		colorCode	: '#616691',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.Grey,
		name		: 'Grey',
		colorCode	: '#7d7f7f',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.Mauve,
		name		: 'Mauve',
		colorCode	: '#915f6d',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.Storm,
		name		: 'Storm',
		colorCode	: '#6e7f99',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.Tan,
		name		: 'Tan',
		colorCode	: '#d2b48c',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.Forest,
		name		: 'Forest',
		colorCode	: '#228b22',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.DarkGrey,
		name		: 'Dark Grey',
		colorCode	: '#5e5f5a'
	},
	{
		code		: EnumMbaColor.HeatherGrey,
		name		: 'Heather Grey',
		colorCode	: '#d7dbdc',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.GreyTieDye,
		name		: 'Grey Tie Dye',
		colorCode	: '#ced2d2',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.KellyGreen,
		name		: 'Kelly Green',
		colorCode	: '#006136'
	},
	{
		code		: EnumMbaColor.KellyGreenWhite,
		name		: 'Kelly Green/White',
		colorCode	: '#d5e7c2',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.Lemon,
		name		: 'Lemon Yellow',
		colorCode	: '#f0e87b'
	},
	{
		code		: EnumMbaColor.Navy,
		name		: 'Navy',
		colorCode	: '#15232b'
	},
	{
		code		: EnumMbaColor.Olive,
		name		: 'Olive',
		colorCode	: '#4a4f26'
	},
	{
		code		: EnumMbaColor.Orange,
		name		: 'Orange',
		colorCode	: '#ff5c39'
	},
	{
		code		: EnumMbaColor.Pink,
		name		: 'Pink',
		colorCode	: '#f8a3bc'
	},
	{
		code		: EnumMbaColor.Lilac,
		name		: 'Lilac',
		colorCode	: '#AF7CAD'
	},
	{
		code		: EnumMbaColor.Plum,
		name		: 'Plum',
		colorCode	: '#9b6984'
	},
	{
		code		: EnumMbaColor.NeonPink,
		name		: 'Neon Pink',
		colorCode	: '#fe5bac'
	},
	{
		code		: EnumMbaColor.Purple,
		name		: 'Purple',
		colorCode	: '#514689'
	},
	{
		code		: EnumMbaColor.PurpleTieDye,
		name		: 'Purple Tie Dye',
		colorCode	: '#dcd6ec',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.Red,
		name		: 'Red',
		colorCode	: '#b71111'
	},
	{
		code		: EnumMbaColor.RaspberryRed,
		name		: 'Raspberry Red',
		colorCode	: '#b75a6c'
	},
	{
		code		: EnumMbaColor.Sapphire,
		name		: 'Sapphire Blue',
		colorCode	: '#0067a5'
	},
	{
		code		: EnumMbaColor.Royal,
		name		: 'Royal',
		colorCode	: '#1c4086'
	},
	{
		code		: EnumMbaColor.Silver,
		name		: 'Silver',
		colorCode	: '#cfd1d1'
	},
	{
		code		: EnumMbaColor.Slate,
		name		: 'Slate',
		colorCode	: '#818189'
	},
	{
		code		: EnumMbaColor.White,
		name		: 'White',
		colorCode	: '#ffffff'
	},
	{
		code		: EnumMbaColor.Beige,
		name		: 'Beige',
		colorCode	: '#fdf3d9'
	},
	{
		code		: EnumMbaColor.BlackAthleticHeather,
		name		: 'Black/Athletic Heather',
		colorCode	: '#aaaaac',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.BlackWhite,
		name		: 'Black/White',
		colorCode	: '#d4baba',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.DarkHeatherWhite,
		name		: 'Dark Heather/White',
		colorCode	: '#daaeae',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.NavyAthleticHeather,
		name		: 'Navy/Athletic Heather',
		colorCode	: '#aaaaac',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.NavyWhite,
		name		: 'Navy/White',
		colorCode	: '#9ba7ea',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.RedWhite,
		name		: 'Red/White',
		colorCode	: '#d69898',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.RoyalBlueWhite,
		name		: 'Royal Blue/White',
		colorCode	: '#7898ea',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.DarkGreen,
		name		: 'Dark Green',
		colorCode	: '#2b4b39'
	},
	{
		code		: EnumMbaColor.Burgundy,
		name		: 'Burgundy',
		colorCode	: '#632131'
	},
	{
		code		: EnumMbaColor.GoldenYellow,
		name		: 'Golden Yellow',
		colorCode	: '#f8b50e'
	},
	{
		code		: EnumMbaColor.PurpleHeather,
		name		: 'Purple Heather',
		colorCode	: '#6e5c99',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.RedHeather,
		name		: 'Red Heather',
		colorCode	: '#cf3d69',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.OliveHeather,
		name		: 'Olive Heather',
		colorCode	: '#80837c',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.PinkHeather,
		name		: 'Pink Heather',
		colorCode	: '#ec6995',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.SageGreen,
		name		: 'Sage Green',
		colorCode	: '#8b9d7e'
	},
	{
		code		: EnumMbaColor.BrightPink,
		name		: 'Bright Pink',
		colorCode	: '#e56594'
	},
	{
		code		: EnumMbaColor.DustyBlue,
		name		: 'Dusty Blue',
		colorCode	: '#8fa8c4'
	},
	{
		code		: EnumMbaColor.BlueTieDye,
		name		: 'Blue Tie Dye',
		colorCode	: '#aab9d8',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.BrushedSteel,
		name		: 'Brushed Steel',
		colorCode	: '#8d8987',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.OrangeWhite,
		name		: 'Orange/White',
		colorCode	: '#ffffff',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.YellowWhite,
		name		: 'Yellow/White',
		colorCode	: '#f7e9bb',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.PinkWhite,
		name		: 'Pink/White',
		colorCode	: '#d67de0',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.BlueWhite,
		name		: 'Blue/White',
		colorCode	: '#8ca9e4',
		isColorIcon	: true
	},
	{
		code 		: EnumMbaColor.LightBlue,
		name 		: 'Light Blue',
		colorCode 	: '#6a9dd6'
	},
	{
		code 		: EnumMbaColor.Ivory,
		name 		: 'Ivory',
		colorCode 	: '#fffff0',
		isColorIcon	: true
	},
	{
		code 		: EnumMbaColor.LightBeige,
		name 		: 'Light Beige',
		colorCode 	: '#f5f5dc',
		isColorIcon	: true
	},
	{
		code 		: EnumMbaColor.LightPink,
		name 		: 'Light Pink',
		colorCode 	: '#ffb6c1',
		isColorIcon	: true
	},
	{
		code 		: EnumMbaColor.LightPurple,
		name 		: 'Light Purple',
		colorCode 	: '#d8bfd8',
		isColorIcon	: true
	},
	{
		code 		: EnumMbaColor.MintGreen,
		name 		: 'Mint Green',
		colorCode 	: '#98ff98',
		isColorIcon	: true
	},
	{
		code 		: EnumMbaColor.Khaki,
		name 		: 'Khaki',
		colorCode 	: '#fffddc'
	},
	{
		code 		: EnumMbaColor.CamoGreen,
		name 		: 'Camo Green',
		colorCode 	: '#4f5925'
	},
	{
		code		: EnumMbaColor.RedWhiteRoyal,
		name		: 'Red/White Royal',
		colorCode	: '#ffa1a1',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.FernTieDye,
		name		: 'Fern Tie Dye',
		colorCode	: '#9ebaa0',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.UmberTieDye,
		name		: 'Umber Tie Dye',
		colorCode	: '#ba9e9e',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.NavyBlue,
		name		: 'Navy Blue',
		colorCode	: '#15232b'
	},
	{
		code		: EnumMbaColor.RoyalBlue,
		name		: 'Royal Blue',
		colorCode	: '#1c4086'
	},
	{
		code		: EnumMbaColor.Pepper,
		name		: 'Pepper',
		colorCode	: '#5c5855'
	},
	{
		code		: EnumMbaColor.BlueJean,
		name		: 'Blue Jean',
		colorCode	: '#7693b1'
	},
	{
		code		: EnumMbaColor.LightGreen,
		name		: 'Light Green',
		colorCode	: '#74aa9f'
	},
	{
		code		: EnumMbaColor.Crimson,
		name		: 'Crimson',
		colorCode	: '#aa4151'
	},
	{
		code		: EnumMbaColor.Orchid,
		name		: 'Orchid',
		colorCode	: '#c1a3c9'
	},
	{
		code		: EnumMbaColor.Espresso,
		name		: 'Espresso',
		colorCode	: '#785E4F'
	},
	{
		code		: EnumMbaColor.RoseQuartz,
		name		: 'Rose Quartz',
		colorCode	: '#EBB0D8'
	},
	{
		code		: EnumMbaColor.Dusk,
		name		: 'Dusk',
		colorCode	: '#836A79'
	},
	{
		code		: EnumMbaColor.Chambray,
		name		: 'Chambray',
		colorCode	: '#B6D9EC'
	},
	{
		code		: EnumMbaColor.SlateGrey,
		name		: 'Slate Grey',
		colorCode	: '#818189'
	},
	{
		code		: EnumMbaColor.SlateGreyWhite,
		name		: 'Slate Grey/White',
		colorCode	: '#d4d4d4',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.WhiteWhite,
		name		: 'White/White',
		colorCode	: '#ffffff',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.MaroonWhite,
		name		: 'Maroon/White',
		colorCode	: '#d4baba',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.AsphaltGrey,
		name		: 'Asphalt Grey',
		colorCode	: '#3f3e3c'
	},
	{
		code		: EnumMbaColor.DarkBlueWhite,
		name		: 'Dark Blue/White',
		colorCode	: '#8ca9e4',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.DarkGreenWhite,
		name		: 'Dark Green/White',
		colorCode	: '#9ba7ea',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.GreenWhite,
		name		: 'Green/White',
		colorCode	: '#d5e7c2',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.PurpleWhite,
		name		: 'Purple/White',
		colorCode	: '#dcd6ec',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.WhiteBlack,
		name		: 'White/Black',
		colorCode	: '#000000',
		isColorIcon	: true
	},
	{
		code		: EnumMbaColor.MultiColor,
		name		: 'Multi-Color',
		colorCode	: '#000000',
		isColorIcon	: true
	}
];

//** Interfaces --------------------------------- */
export interface IAmazonMbaColor {
	code		: EnumMbaColor;			// example: forest_green
	name		: string;				// example: Forest Green
	colorCode	: string;				// example: #0f5b20
	isColorIcon?: boolean;
}
